import React from "react";
const ContextAPI = React.createContext();
 

export default ContextAPI;